import type { GameEvent } from '../game/state';
import { midiFrequency, type ToneEvent } from './ay38910';
export type EffectName=GameEvent['type']|'menu';
export function effect(name:EffectName,now:number,cause?:string):ToneEvent[]{
  const tone=(frequency:number,duration:number,offset=0,channel:0|1|2=2,noise=false,endFrequency?:number):ToneEvent=>({frequency,duration,at:now+0.005+offset,channel,noise,endFrequency,volume:13,priority:5,category:'sfx',envelope:'decay'});
  const arpeggio=(notes:number[],duration=0.085):ToneEvent[]=>notes.map((n,i)=>tone(midiFrequency(n),duration,i*duration));
  switch(name){
    case 'hop':return[tone(1000,0.065,0,2,false,260)];
    case 'menu':return[tone(740,0.045)];
    case 'start':return arpeggio([60,67,76,84],0.09);
    case 'ready':return[];
    case 'home':return arpeggio([79,83,86,91],0.1);
    case 'death':{
      if(cause==='timeout')return[tone(880,0.14,0,1),tone(660,0.14,0.14,1),tone(220,0.3,0.28,2,false,55)];
      if(cause==='crocodile'||cause==='otter')return[tone(180,0.12,0,1,true,60),tone(360,0.18,0.13,2,true,75)];
      const frequency=cause==='water'||cause==='turtle'?240:cause==='truck'?160:cause==='race'?1200:620;
      return [tone(frequency,0.38,0,1,true,50),tone(420,0.26,0.12,2,false,80)];
    }
    case 'fly':return arpeggio([88,95,100],0.055);
    case 'lady':return arpeggio([76,81,88],0.07);
    case 'lady-home':return arpeggio([81,88,93,100],0.075);
    case 'level':return arpeggio([72,76,79,84,79,83,86,91],0.13);
    case 'extra-life':return arpeggio([84,88,91,96,100],0.08);
    case 'game-over':return arpeggio([67,64,60,55,48],0.2);
    case 'warning':return [tone(880,0.1),tone(880,0.1,0.2),tone(880,0.1,0.4)];
  }
}
